import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProvisionRoutes = defineRoute({
    record: {
        route: {
            path: "/provision",
            component: () => loadView(import("./ProvisionTable.vue")),
        },
    },
    create: {
        route: {
            path: "/provision/create",
            component: () => loadView(import("./ProvisionCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/provision/detail/:id",
            component: () => loadView(import("./ProvisionDetail.vue")),
        },
        build(id: string) {
            return `/provision/detail/${id}`;
        },
    },
});
